



























import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GStudentRecordCompetencyScoreTransition',
  computed: {},
  methods: {},
})
export default class GStudentRecordCompetencyScoreTransition extends mixins(GPageBase) {
  @Prop() beforeScore: number;
  @Prop() beforeScoreStatus: string;
  @Prop() afterScore: number;
  @Prop() afterScoreStatus: string;
  @Prop() isCompetencyScoreLess: boolean;
}
